module.exports = __webpack_public_path__ + "img/抠鼻.3fb089f1.png";